// The share email deep-links a clip as /video_centre/clips/shared_with_me?clip_id=N.
// Clips have no standalone page, so the clips view renders a hidden #clips-deep-link
// carrying the clip URL and we fire the very same request the row click already makes.
// The response is the JS that fills and opens #clips-modal.
export function openDeepLinkedClip() {
  const hook = document.getElementById("clips-deep-link");
  if (!hook) return false;

  const url = hook.dataset.url;
  if (!url) return false;

  // Fire once. turbolinks:load runs again on restoration visits (back/forward),
  // replaying the cached DOM - and the cache snapshot is taken when we navigate
  // away, so dropping the hook now keeps the modal from popping open unprompted
  // on the way back.
  hook.remove();

  $.ajax({
    url: url,
    headers: {
      "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
    },
  });

  return true;
}

export default openDeepLinkedClip;
